'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCcAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#229716" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33333 8C3.86057 8 2.66667 6.80609 2.66667 5.33333C2.66667 3.86057 3.86057 2.66667 5.33333 2.66667C6.80609 2.66667 8 3.86057 8 5.33333C8 6.80609 6.80609 8 5.33333 8ZM5.33333 5.33333C5.61094 5.33333 5.11987 6.73925 5.33333 6.66667C5.6861 6.54672 6.66667 4.89605 6.66667 4.66667C6.66667 4.29848 6.06971 4 5.33333 4C4.59695 4 4 4.29848 4 4.66667C4 5.03486 4.59695 5.33333 5.33333 5.33333Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3334 17.3334L20.3905 17.6095L20.6667 16.6667L20.3905 15.7239L21.3334 16L22.2762 15.7239L22 16.6667L22.2762 17.6095L21.3334 17.3334Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3334 4.66669L20.3905 4.94283L20.6667 4.00002L20.3905 3.05721L21.3334 3.33335L22.2762 3.05721L22 4.00002L22.2762 4.94283L21.3334 4.66669Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.3334 8.66669L24.3905 8.94283L24.6667 8.00002L24.3905 7.05721L25.3334 7.33335L26.2762 7.05721L26 8.00002L26.2762 8.94283L25.3334 8.66669Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.6667 10L17.7239 10.2762L18 9.33335L17.7239 8.39054L18.6667 8.66669L19.6095 8.39054L19.3334 9.33335L19.6095 10.2762L18.6667 10Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.3333 11.6666L22.8619 11.8047L23 11.3333L22.8619 10.8619L23.3333 11L23.8047 10.8619L23.6667 11.3333L23.8047 11.8047L23.3333 11.6666Z",
          fill: "#FFE244"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.0818 7.39655C15.5114 6.93982 14.7876 6.66667 14 6.66667C12.1591 6.66667 10.6667 8.15905 10.6667 10C10.6667 11.8409 12.1591 13.3333 14 13.3333C14.7876 13.3333 15.5114 13.0602 16.0818 12.6035C15.7796 12.7162 15.4526 12.7778 15.1111 12.7778C13.577 12.7778 12.3333 11.5341 12.3333 10C12.3333 8.46588 13.577 7.22222 15.1111 7.22222C15.4526 7.22222 15.7796 7.28383 16.0818 7.39655Z",
          fill: "#FFE244"
        }
      )
    ]
  }
);
const VpFlagCcAsset = forwardRef(FlagCcAsset);

export { VpFlagCcAsset as default };
